import type { PlaybookAsset } from '@carboncopyco/types';
import { CustomizeDemo } from './CustomizeDemo';
import { CustomizeExternalUrl } from './CustomizeExternalUrl';
import { CustomizeTour } from './CustomizeTour';

type AssetTabSwitchProps = {
  selectedId: string;
  entityType: PlaybookAsset['assetType'];
};
export const AssetTabSwitch = ({
  selectedId,
  entityType,
}: AssetTabSwitchProps) => {
  switch (entityType) {
    case 'demo':
      return <CustomizeDemo entityId={selectedId} />;
    case 'tour':
      return <CustomizeTour entityId={selectedId} />;
    case 'externalUrl':
      return <CustomizeExternalUrl entityId={selectedId} />;
  }
};
